import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'epDropdown',
    standalone: false
})
export class EpDropdownPipe implements PipeTransform {

  transform(pplNames: any, searchName: string): any {
    if (!pplNames) { /// solve async issue temprory
      return []; // this solved the null problem
    }
    const arr = [...pplNames]; // =ARR.SLICE

    // new Set to for loop every string in the arr, push no duplicate string to new array: arrShortt[]
    const arrSett = new Set(arr);
    let arrShortt = [];
    arrSett.forEach(element => {
      // remove the propName's value is null:
      if (element !== null) {
        arrShortt.push(element);
      }
    });
    // filter not only first name, but also last name. also make change in dropdown.ts detectInput()
    // split every data(string) into several strings, firstName,lastName and ...,
    // for loop them and find 1st alpha same with search input alpha, return true.
    arrShortt = arrShortt.filter(data => {
      if(data) {
        const splitData = data.split(' ');
        for (const i of splitData) {
          if ((i.toLowerCase()).indexOf(searchName.toLowerCase()) === 0
            || (data.toLowerCase()).indexOf(searchName.toLowerCase()) === 0) { // || data.indexOf((searchName)===0)
            return true;
          }
      }
      }
      return false;
    });
    return arrShortt;
  }
}
